import React, { useState, useEffect } from 'react';
import { TitrantStandardization } from '../models/titrant-standardization';
import { CrudFunctions } from '../utilities/crud-functions';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';

import DataGrid, {
    Column,
    Paging,
    Button as ColumnButton,
    Toolbar,
    Selection,
    Lookup,
    Editing,
    Item as ToolbarItem
} from 'devextreme-react/data-grid';

import { Popup as DialogPopup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';


export interface Props {
    benchSheetId?: string;
    batchId?: string;
    isReadOnly: boolean;
    datagridHeight?: string;
    title?: string;
}

export default function TitrantStandardizationsComponent(props: Props) {
    const [titrantStandardizations, setTitrantStandardizations] =
        useState<TitrantStandardization[]>();

    const [selectedTitrantStandardization, setSelectedTitrantStandardizations] =
        useState<TitrantStandardization>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, [props.benchSheetId]);

    return (
        <div>
            <div className="pw-comp-row">
                <DataGrid
                    height="10rem"
                    keyExpr="titrantStandardizationId"
                    dataSource={titrantStandardizations ? titrantStandardizations : []}
                    onRowValidating={onTitrantStandardizationRowValidating}
                    onRowRemoving={onTitrantStandardizationRemoving}
                    rowAlternationEnabled={true}
                    showBorders={true}>

                    <Paging enabled={false} />
                    <Selection mode='single' />

                    <Column dataField='titerValue' dataType="number" width="8rem" />
                    <Column dataField='result' dataType="number" width="8rem" />
                    <Column />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Standardization of Titrants</div>
                            </div>
                        </ToolbarItem>

                        <ToolbarItem name="addRowButton" location='after' />
                    </Toolbar>

                    <Editing
                        mode="row"
                        useIcons={true}
                        allowAdding={!props.isReadOnly}
                        allowUpdating={!props.isReadOnly}
                        allowDeleting={!props.isReadOnly} >
                    </Editing>

                </DataGrid>
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    async function onTitrantStandardizationRowValidating(e: any) {
        if (e.oldData) {
            let titrantStandardization = e.oldData as TitrantStandardization;

            if (titrantStandardization) {
                let updatedTitrantStandardization = { ...titrantStandardization, ...e.newData };

                updateTitrantStandardization(updatedTitrantStandardization)
                    .then(() => {
                        getTitrantStandardizarions();
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Titrant Standardization");
                    });
            }
        }
        else {
            if (e.newData) {
                let titrantStandardization = e.newData as TitrantStandardization;

                if (titrantStandardization) {
                    titrantStandardization.benchSheetId = props.benchSheetId;

                    await insertTitrantStandardization(titrantStandardization)
                        .then(data => {
                            getTitrantStandardizarions();
                        })
                        .catch((res) => {
                            showMessage(res, ModalMessageType.Error, "Error Inserting Titrant Standardization");
                        });
                }
            }
        }
    }

    function onTitrantStandardizationRemoving(e: any) {
        let titrantStandardizationId = e.data.titrantStandardizationId;

        deleteTitrantStandardization(titrantStandardizationId)
            .then(() => {
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Deleting Titrant Standardization");
            });
    }

    async function getTitrantStandardizarions() {
        if (props.benchSheetId)
            await CrudFunctions.getData(`benchsheets/titrantstandardizations/${props.benchSheetId}`)
                .then(data => {
                    setTitrantStandardizations(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Titrant Standardizations");
                });
    }

    async function insertTitrantStandardization(titrantstandardization: TitrantStandardization) {
        await CrudFunctions.postData("benchsheets/titrantstandardization", titrantstandardization);
    }

    async function updateTitrantStandardization(titrantstandardization: TitrantStandardization) {
        await CrudFunctions.putData("benchsheets/titrantstandardization", titrantstandardization);
    }

    async function deleteTitrantStandardization(titrantStandardizationId: string) {
        await CrudFunctions.deleteData(`benchsheets/titrantstandardization/${titrantStandardizationId}`);
    }

    function getAllData() {
        getTitrantStandardizarions();

    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

}





